<template>
    <el-dialog
        width="500px"
        :title="pageType ==1 ? '添加箱子信息' : '修改箱子信息'"
        top="3vh"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >
        <el-form ref="formData" class="query-form" size="mini" :rules="rules" :model="formData">
            <el-form-item label="箱子规格：" prop="specification">
                <el-input v-model="formData.specification" placeholder="请输入箱子规格" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="箱数：" prop="box_number">
                <el-input-number
                    v-model="formData.box_number"
                    style="width: 300px;" :min="0" :step="1" size="mini"
                    placeholder="请输入箱数"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="箱重：" prop="box_weight">
                <el-input-number
                    v-model="formData.box_weight"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入箱重"
                >
                </el-input-number>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" type="primary" size="mini">关 闭</el-button>
        <el-button @click="addBox" type="success" size="mini" v-show="pageType==1">添加</el-button>
        <el-button @click="addBox" type="success" size="mini" v-show="pageType==2">修改</el-button>
    </span>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                pageType: 1,
                rules: {
                    specification: [
                        {
                            required: true,
                            message: '请输入箱子规格',
                            trigger: 'blur'
                        },
                    ],
                    box_number: [
                        {
                            required: true,
                            message: '请输入箱数',
                            trigger: 'blur'
                        },
                    ],
                    box_weight: [
                        {
                            required: true,
                            message: '请输入箱重',
                            trigger: 'blur'
                        },
                    ],
                },
                visible: false,
                formData: {
                    specification: undefined,
                    box_number: undefined,
                    box_weight: undefined,
                },
            }
        },
        created() {
        },
        methods: {
            openModal(type, data) {
                this.pageType = type
                if (type == 2) {
                    this.formData = data
                }
                this.visible = true
            },
            showModal(data) {
                this.formData = data
                this.visible = true
            },
            // 关闭弹窗
            handleClose() {
                this.visible = false
                this.$emit('close-callback', {flag: false})
            },
            addBox() {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        this.$emit('close-callback', {
                            flag: true,
                            pageType: this.pageType,
                            data: JSON.parse(JSON.stringify({items: [], ...this.formData})),
                            id: Math.random()
                        })
                        this.initFormData()
                        this.visible = false
                    } else {
                        this.loading = false
                        this.$message({type: 'error', message: '请填写相应内容！'})
                    }
                })
            },
            initFormData() {
                this.formData = {
                    specification: undefined,
                    box_number: undefined,
                    box_weight: undefined,
                }
            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .subTitle {
        height: 30px;
        font-size: 18px;
        font-weight: 800;
        margin: 5px 0 0;
    }

    .subTitle2 {
        height: 20px;
        font-size: 16px;
        font-weight: 800;
    }

    .itemInfo {
        display: flex;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 800;
        }

        .itemContent {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .itemInfo:not(:first-child) {
        margin-top: 5px;
    }

    .lineDom {
        width: auto;
        height: 1px;
        background: black;
        margin: 10px 0;
    }

    .wrapBox {
        width: 600px;
        margin-top: 10px;

        .bottomBox {
            margin-top: 17px;
            display: flex;
            justify-content: center;
        }
    }

    .download {
        display: flex;
        justify-content: center;
    }

    .top {
        margin: 0px auto 20px;
        width: 60%;
        display: flex;
        justify-content: space-between;
    }
</style>
